import { makeStyles } from '@mui/styles';

export const useTimelineQRBubbleStyles = makeStyles((theme) => ({
  desktopCard: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '1.5rem',
    marginTop: '1rem',
    width: '80%',
    [theme.breakpoints.down('sm')]: {
      width: 'auto'
    }
  },
  mobileCard: {
    display: 'flex',
    flexDirection: 'column',
    padding: '8px 8px 8px 16px',
    marginTop: '1rem'
  },
  title: {
    fontSize: '14px',
    fontWeight: 500,
    marginBottom: '1rem'
  },
  message: {
    fontSize: '11px',
    marginTop: '1rem',
    marginBottom: 0
  }
}));
